import React from 'react';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useCreditAppsTabDataFetch } from 'modules/customers/hooks/useCreditAppsTabDataFetch';
import { CreditAppsTabFallback } from './CreditAppsTabFallback';
import { CreditAppsCard } from './CreditAppsCard';

export const CustomerDetailsCreditAppsTab = () => {
  const { id: customerAccountId } = useParams<{ id: string }>();
  const { isLoading, creditAppsTableData } = useCreditAppsTabDataFetch(customerAccountId);

  if (isLoading) {
    return <CreditAppsTabFallback />;
  }

  return (
    <Stack gap={1}>
      <CreditAppsCard creditAppsTableData={creditAppsTableData} />
    </Stack>
  );
};
